import React, { PureComponent } from "react";
import _ from "lodash";
import { HotKeys } from "react-hotkeys";
import styled from "styled-components";

import store, {
  updateProperties,
  isCanvasSelected,
  selectedBlock,
  doToSelected,
  duplicateBlock,
  copyBlock,
  cutBlock,
  pasteBlock,
  deleteBlock,
  expandDown,
  expandUp,
  expandLeft,
  expandRight,
  moveDownFull,
  moveRightFull,
  bringBlockToFront,
  sendBlockToBack,
  undo,
  redo
} from "../canvas/store";

import { stopPreview } from "./index";
import { Divider } from "../reusable/layout";

const keyMap = {
  moveLeft: "left",
  moveRight: "right",
  moveUp: "up",
  moveDown: "down",
  undo: ["command+z", "ctrl+z"],
  redo: ["command+shift+z", "ctrl+shift+z"],
  copy: ["command+c", "ctrl+c"],
  paste: ["command+v", "ctrl+v"],
  cut: ["command+x", "ctrl+x"],
  remove: "backspace",
  moveLeftMore: "shift+left",
  moveRightMore: "shift+right",
  moveUpMore: "shift+up",
  moveDownMore: "shift+down",
  moveLeftFull: ["command+left", "ctrl+left"],
  moveRightFull: ["command+right", "ctrl+right"],
  moveUpFull: ["command+up", "ctrl+up"],
  moveDownFull: ["command+down", "ctrl+down"],
  expandRight: ["shift+command+right", "shift+ctrl+right"],
  expandLeft: ["shift+command+left", "shift+ctrl+left"],
  expandUp: ["shift+command+up", "shift+ctrl+up"],
  expandDown: ["shift+command+down", "shift+ctrl+down"],
  bringFront: ["alt+up"],
  sendBack: ["alt+down"],
  stopPreview: ["escape"]
};

const ShortCut = styled.li`
  display: flex;
  padding: 15px 10px;
`;

const Keys = styled.div`
  width: 50%;
  text-align: right;
`;

const Key = styled.span`
  padding: 5px;
  border: 1px solid #555;
  border-radius: 5px;
  margin-right: 3px;
`;

export const KeyMapList = p => {
  return (
    <ul>
      {_.map(keyMap, (keys, action) =>
        <ShortCut key={action}>
          <Keys>
            {_.flatten([keys]).map(k =>
              <Key key={k}>
                {k}
              </Key>
            )}
          </Keys>
          <Divider w="15px" />
          <div>
            {action}
          </div>
        </ShortCut>
      )}
    </ul>
  );
};

export default WrappedComponent => {
  return class extends PureComponent {
    moveSelectedBy = (x, y) =>
      !isCanvasSelected() &&
      updateProperties(store.selected, {
        left: selectedBlock().left + x,
        top: selectedBlock().top + y
      });

    moveSelectedByFn = (x, y) => () => this.moveSelectedBy(x, y);

    keyHandlers = {
      moveLeft: this.moveSelectedByFn(-1, 0),
      moveRight: this.moveSelectedByFn(1, 0),
      moveUp: this.moveSelectedByFn(0, -1),
      moveDown: this.moveSelectedByFn(0, 1),
      moveLeftMore: this.moveSelectedByFn(-20, 0),
      moveRightMore: this.moveSelectedByFn(20, 0),
      moveUpMore: this.moveSelectedByFn(0, -20),
      moveDownMore: this.moveSelectedByFn(0, 20),
      moveLeftFull: () => updateProperties(store.selected, { left: 0 }),
      moveRightFull: () => !isCanvasSelected() && doToSelected(moveRightFull)(),
      moveDownFull: () => !isCanvasSelected() && doToSelected(moveDownFull)(),
      moveUpFull: () => updateProperties(store.selected, { top: 0 }),
      duplicate: () => !isCanvasSelected() && doToSelected(duplicateBlock)(),
      copy: () => !isCanvasSelected() && doToSelected(copyBlock)(),
      cut: () => !isCanvasSelected() && doToSelected(cutBlock)(),
      paste: () => pasteBlock(),
      remove: () => !isCanvasSelected() && doToSelected(deleteBlock)(),
      bringFront: doToSelected(bringBlockToFront),
      sendBack: doToSelected(sendBlockToBack),
      expandUp: () => !isCanvasSelected() && doToSelected(expandUp)(),
      expandDown: () => !isCanvasSelected() && doToSelected(expandDown)(),
      expandRight: () => !isCanvasSelected() && doToSelected(expandRight)(),
      expandLeft: () => !isCanvasSelected() && doToSelected(expandLeft)(),
      undo: undo,
      redo: redo,
      stopPreview: () => stopPreview()
    };

    keyHandlersPvtD = handlers =>
      _.mapValues(handlers, h => e => {
        if (e.target.nodeName !== "INPUT") {
          e.preventDefault();
          h();
        }
      });

    render() {
      return (
        <HotKeys keyMap={keyMap} handlers={this.keyHandlersPvtD(this.keyHandlers)}>
          <WrappedComponent {...this.props} ref={a => (this.app = a)} />
        </HotKeys>
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/layout/hotkeys.js